/** Give visible content a paint opportunity before optional initialization. */
export function afterPaint(callback: () => void): () => void {
  let idle: number | undefined;
  let timer: number | undefined;
  let frame = requestAnimationFrame(() => {
    frame = requestAnimationFrame(() => {
      if (typeof requestIdleCallback === "function") idle = requestIdleCallback(callback, { timeout: 1500 });
      else timer = window.setTimeout(callback, 0);
    });
  });
  return () => {
    cancelAnimationFrame(frame);
    if (idle !== undefined) cancelIdleCallback(idle);
    if (timer !== undefined) window.clearTimeout(timer);
  };
}
